import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { API, getAuthHeader } from "@/App";

const KINDS = [
  ["parties", "Customers & suppliers", "Party / Ledger Name, GSTIN, State, Address, Mobile, Opening Balance, Dr/Cr, Group (Sundry Debtors / Creditors)"],
  ["products", "Products", "Item Name, Packing, Company, HSN Code, GST %, Generic / Salt, Unit, Sale Rate / MRP"],
  ["stock", "Opening stock (batch-wise)", "Item Name, Batch No, Expiry, Cl. Qty / Stock, P.Rate / Cost (+ product columns above)"],
];

const ImportCard = ({ company, kind, label, cols }) => {
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const [ptype, setPtype] = useState("customer");
  const upload = async (file) => {
    if (!file) return;
    setBusy(true); setRes(null);
    const fd = new FormData(); fd.append("file", file);
    try {
      const { data } = await axios.post(`${API}/acc/import/${kind}?company_id=${company.id}&party_type=${ptype}`, fd,
        { headers: { ...getAuthHeader(), "Content-Type": "multipart/form-data" }, timeout: 120000 });
      setRes(data);
      toast.success(`${label}: ${data.created} new, ${data.updated} updated${kind === "stock" ? `, ${data.batches} batch(es)` : ""}`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Import failed"); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2 rounded-xl border bg-white p-4" data-testid={`acc-import-${kind}`}>
      <div className="font-semibold">{label}</div>
      <p className="text-xs text-slate-500">Columns read (any order, Marg names work): {cols}</p>
      {kind === "parties" && <label className="block text-xs">If the file has no Group column, treat rows as
        <select value={ptype} onChange={e => setPtype(e.target.value)} className="ml-1 rounded border px-1 py-0.5" data-testid="acc-import-ptype">
          <option value="customer">customers</option><option value="supplier">suppliers</option></select></label>}
      <label className="inline-flex cursor-pointer items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold text-white" style={{ background: "var(--acc)" }}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Upload Excel / CSV
        <input type="file" accept=".xlsx,.xls,.csv" className="hidden" onChange={e => { upload(e.target.files[0]); e.target.value = ""; }} data-testid={`acc-import-file-${kind}`} /></label>
      {res && <div className="rounded bg-slate-50 p-2 text-xs" data-testid={`acc-import-result-${kind}`}>
        {res.rows} rows · {res.created} created · {res.updated} updated{kind === "stock" ? ` · ${res.batches} batches` : ""}
        <div className="text-slate-500">Matched columns: {Object.entries(res.columns).map(([k, v]) => `${v} → ${k}`).join(", ")}</div></div>}
    </div>
  );
};

export const ImportTab = ({ company }) => (
  <div className="space-y-3" data-testid="acc-import">
    <p className="text-xs text-slate-500">Export the masters from Marg (Excel), then upload here into {company.name}. Existing names are updated, not duplicated. Re-uploading opening stock replaces untouched opening batches.</p>
    <div className="grid gap-3 md:grid-cols-3">{KINDS.map(([k, l, c]) => <ImportCard key={k} company={company} kind={k} label={l} cols={c} />)}</div>
  </div>
);
